import React from 'react';
import Button from '~/app/common/Button';
import classes from './style.module.scss';

export interface QuantityProps {
  quantity: number
  quantityChange: (value: number) => void
}

export type QuantityComponent = React.FC<QuantityProps>

const Quantity: QuantityComponent = ({ quantity, quantityChange }) => {

  const handleQuantityChange = (delta: number) => {
    const qty = Math.max(0, quantity + delta);
    quantityChange(qty);
  };

  const handleQuantityInputChange = (value: string) => {
    const num = parseInt(value, 10);
    const qty = isNaN(num) || num < 0 ? 0 : num;
    quantityChange(qty);
  };

  return (
    <div className={classes['quantityControls']}>
      <Button onClick={() => handleQuantityChange(-1)} disabled={quantity <= 0}>-</Button>
      <input
        type="number"
        min={0}
        value={quantity ? (quantity.toString().replace(/^0+/, '')) : 0}
        onChange={e => handleQuantityInputChange(e.target.value)}
        className={classes['quantityInput']}
        style={{ minWidth: (quantity.toString().length + 1) + 'ch' }}
      />
      <Button onClick={() => handleQuantityChange(1)}>+</Button>
    </div>
  );
}

export default Quantity;